import { Optional } from '../../../types.js';
import { ValueFormatter } from '../../common/format.js';
import { KeyScale } from '../axis/key/KeyScale.js';
import { ValueScale } from '../axis/value/ValueScale.js';
import { getTickPlacementInfo } from '../axis/value/utils.js';
import { OneUxPlotChartTypographyToken, bounds, yTarget } from '../types.js';
import { calculatePointLabelRect } from './calculatePointLabelRect.js';
export class PointLabelCollisionManager {
  #collisonRects: DOMRect[] = [];
  #disabled = false;
  constructor(disabled = false) {
    this.#disabled = disabled;
  }
  public get collisonRects() {
    return [...this.#collisonRects];
  }
  public registerCollisionRectsForValueScale(valueScale: Optional<ValueScale>, yTarget: yTarget, valueFormatter: ValueFormatter) {
    if (!valueScale || this.#disabled) return;
    for (const tick of valueScale.ticks) {
      const {
        x,
        y,
        textAnchor,
        text,
        alignment,
        typography
      } = getTickPlacementInfo(valueScale, yTarget, valueFormatter, tick);
      const rect = calculatePointLabelRect(text, x, y, 0, 0, textAnchor, alignment, typography);
      this.#collisonRects.push(rect);
    }
  }
  public isCollision(text: string, x: number, y: number, dx: number, dy: number, textAnchor: 'middle' | 'start' | 'end', dominantBaseline: 'auto' | 'middle' | 'hanging', typography: OneUxPlotChartTypographyToken) {
    if (this.#disabled) {
      return false;
    }
    const currentRect = calculatePointLabelRect(text, x, y, dx, dy, textAnchor, dominantBaseline, typography);
    let isCollision = false;
    for (const rect of this.#collisonRects) {
      if (this.#isIntersection(currentRect, rect)) {
        isCollision = true;
        break;
      }
    }
    if (!isCollision) {
      this.#collisonRects.push(currentRect);
    }
    return isCollision;
  }
  public isIntersectingKeyScale(keyScale: KeyScale, text: string, x: number, y: number, dx: number, dy: number, textAnchor: 'middle' | 'start' | 'end', dominantBaseline: 'auto' | 'middle' | 'hanging') {
    const bounds = keyScale.bounds;
    const currentRect = calculatePointLabelRect(text, x, y, dx, dy, textAnchor, dominantBaseline, keyScale.fontToken);
    return this.#isIntersection(bounds, currentRect);
  }
  #isIntersection(a: DOMRect | bounds, b: DOMRect | bounds) {
    return !(b.left > a.right || b.right < a.left || b.top > a.bottom || b.bottom < a.top);
  }
}